export const SET_CALCULATING_ZOOM = 'SET_CALCULATING_ZOOM'
export const SET_PREVIEW_ZOOM = 'SET_PREVIEW_ZOOM'

export default {
  [SET_CALCULATING_ZOOM] (state, isCalculatingZoom) {
    state.isCalculatingZoom = isCalculatingZoom
  },
  [SET_PREVIEW_ZOOM] (state, previewZoom) {
    state.previewZoom = previewZoom
  },
}